import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Location } from '@/types/types';

const initialState = {
    productId: 0,
    locations: [] as Location[]
}

const productLocatorSlice = createSlice({
    name: 'productLocator',
    initialState: initialState,
    reducers: {
        locatingStarted: (state, action: PayloadAction<number>) => {
            state.productId = action.payload;
        },

        locationAdded: (state, action: PayloadAction<Location>) => {
            state.locations.push(action.payload);
        },

        locatingReset: (state) => {
            state.productId = 0;
            state.locations = [];
        },
    }
})

export const { locatingStarted, locationAdded, locatingReset } = productLocatorSlice.actions;
export default productLocatorSlice.reducer;
